// IMPORT SCRIPTS

import Forms from './forms';
import Heroes from './heroes';
import Images from './images';
import Navigation from './navigation';
import Routings from './routings';
import Video from './video';

import GuestList from './guest-list/script';

// IMPORT QUERIES
// query groups

import formAttendQuery from './forms/form-attend/query';
import formSignInQuery from './forms/form-sign-in/query';

import heroCollaboratorsQuery from './heroes/collaborators/query';
import heroExperienceQuery from './heroes/experience/query';
import heroGenericQuery from './heroes/generic/query';
import heroHomeQuery from './heroes/home/query';
import heroInterviewQuery from './heroes/interview/query';
import heroTextQuery from './heroes/text/query';
import heroBottomQuery from './heroes/bottom/query';

import imagePrimary from './images/image-primary/query';
import imageShowcase from './images/image-showcase/query';
import imageTextSplitQuery from './images/image-text-split/query';

import routingExperienceQuery from './routings/experience/query';
import routingInterviewQuery from './routings/interview/query';
import routingPageQuery from './routings/page/query';

import showcaseArtistsQuery from './showcase/artists/query';
import showcaseFeaturingQuery from './showcase/featuring/query';

import textBadgeQuery from './text/badge/query';
import textButtonAssetQuery from './text/button-asset/query';
import textButtonUrlQuery from './text/button-url/query';
import textColumnQuery from './text/column/query';
import textLargeQuery from './text/large/query';
import textSimpleQuery from './text/simple/query';
import textVisionQuery from './text/vision/query';

// misc queries

import bannerBadgeQuery from './banners/badge/query';
import faqQuery from './faq/query';
import galleryQuery from './gallery/query';
import guestListQuery from './guest-list/query';
import instructionsQuery from './instructions/query';
import interviewQuery from './interview/query';
import sponsorsQuery from './sponsors/query';
import teamQuery from './team/query';
import videoBannerQuery from './video/video-banner/query';

// EXPORT SCRIPTS

export default {
	// indexes
	...Forms,
	...Heroes,
	...Images,
	...Navigation,
	...Routings,
	...Video,

	[GuestList.selector]: GuestList
};

// EXPORT QUERIES & ASSOCIATE WITH MODULE TEMPLATES

export const moduleQueries = {

	// forms

	ModulesFormAttend: {
		query: formAttendQuery,
		template: 'forms/form-attend'
	},
	ModulesFormSignIn: {
		query: formSignInQuery,
		template: 'forms/form-sign-in'
	},

	// heroes

	ModulesHeroCollaborators: {
		query: heroCollaboratorsQuery,
		template: 'heroes/collaborators'
	},
	ModulesHeroExperience: {
		query: heroExperienceQuery,
		template: 'heroes/experience'
	},
	ModulesHeroGeneric: {
		query: heroGenericQuery,
		template: 'heroes/generic'
	},
	ModulesHeroHome: {
		query: heroHomeQuery,
		template: 'heroes/home'
	},
	ModulesHeroInterview: {
		query: heroInterviewQuery,
		template: 'heroes/interview'
	},
	ModulesHeroText: {
		query: heroTextQuery,
		template: 'heroes/text'
	},
	ModulesHeroBottom: {
		query: heroBottomQuery,
		template: 'heroes/bottom'
	},

	// images

	ModulesImage: {
		query: imagePrimary,
		template: 'images/image-primary'
	},
	ModulesImageShowcase: {
		query: imageShowcase,
		template: 'images/image-showcase'
	},
	ModulesImageTextSplit: {
		query: imageTextSplitQuery,
		template: 'images/image-text-split'
	},

	// texts

	ModulesTextBadge: {
		query: textBadgeQuery,
		template: 'text/badge'
	},
	ModulesTextButtonAsset: {
		query: textButtonAssetQuery,
		template: 'text/button-asset'
	},
	ModulesTextButtonUrl: {
		query: textButtonUrlQuery,
		template: 'text/button-url'
	},
	ModulesTextColumn: {
		query: textColumnQuery,
		template: 'text/column'
	},
	ModulesTextLarge: {
		query: textLargeQuery,
		template: 'text/large'
	},
	ModulesTextSimple: {
		query: textSimpleQuery,
		template: 'text/simple'
	},
	ModulesTextVision: {
		query: textVisionQuery,
		template: 'text/vision'
	},

	// routings

	ModulesRoutingExperience: {
		query: routingExperienceQuery,
		template: 'routings/experience'
	},
	ModulesRoutingInterview: {
		query: routingInterviewQuery,
		template: 'routings/interview'
	},
	ModulesRoutingPage: {
		query: routingPageQuery,
		template: 'routings/page'
	},

	// showcases

	ModulesShowcaseArtists: {
		query: showcaseArtistsQuery,
		template: 'showcase/artists'
	},
	ModulesShowcaseFeaturing: {
		query: showcaseFeaturingQuery,
		template: 'showcase/featuring'
	},

	// misc

	ModulesBannerBadge: {
		query: bannerBadgeQuery,
		template: 'banners/badge'
	},
	ModulesFaq: {
		query: faqQuery,
		template: 'faq'
	},
	ModulesGallery: {
		query: galleryQuery,
		template: 'gallery'
	},
	ModulesGuestList: {
		query: guestListQuery,
		template: 'guest-list'
	},
	ModulesInstructions: {
		query: instructionsQuery,
		template: 'instructions'
	},
	ModulesInterview: {
		query: interviewQuery,
		template: 'interview'
	},
	ModulesSponsors: {
		query: sponsorsQuery,
		template: 'sponsors'
	},
	ModulesTeam: {
		query: teamQuery,
		template: 'team'
	},
	ModulesVideo: {
		query: videoBannerQuery,
		template: 'video/video-banner'
	}
};
